import { Chart } from 'chart.js/auto';

import { createEngagementChart } from '../../../graphs/engagement_chart';
import { createFundRaisingAndDistributionChart } from '../../../graphs/fundraising_and_distribution_chart';
import { initPdfExport } from './index/pdf_export';
import './profile_filters';

$(function() {
  if (!document.getElementById('profile-filter')) return;

  initGraphAndTables();
  initSpreadsheetExportForm();
  initPdfExport();
});

function initGraphAndTables() {
  const $form = $('#profile-filter');
  let currentEngagementScope = 'individual';
  let currentFundraisingScope = 'individual';

  generateGraphsAndTablesFromProfilesFilter($form, currentEngagementScope, currentFundraisingScope);

  $form.on("submit", e => {
    e.preventDefault();
    generateGraphsAndTablesFromProfilesFilter($form, currentEngagementScope, currentFundraisingScope);
  });

  // Engagement tabs

  $('#global-engagement-tab').on('click', e => {
    if (currentEngagementScope === 'global') {
      return;
    } else {
      currentEngagementScope = 'global';
      let existingEngagementChart = Chart.getChart('engagementChartCanvas');
      if (existingEngagementChart !== undefined) { existingEngagementChart.destroy() }

      createEngagementChart(JSON.parse(localStorage.getItem('graphData')), currentEngagementScope);
    }
  })

  $('#individual-engagement-tab').on('click', e => {
    if (currentEngagementScope === 'individual') {
      return;
    } else {
      currentEngagementScope = 'individual';
      let existingEngagementChart = Chart.getChart('engagementChartCanvas');
      if (existingEngagementChart !== undefined) { existingEngagementChart.destroy() }

      createEngagementChart(JSON.parse(localStorage.getItem('graphData')), currentEngagementScope);
    }
  })

  // Fundraising tabs

  $('#global-fundraising-tab').on('click', e => {
    if (currentFundraisingScope === 'global') {
      return;
    } else {
      currentFundraisingScope = 'global';
      let existingFundraisingChart = Chart.getChart('fundraisingAndDistributionChartCanvas');

      if (existingFundraisingChart != null) {
        existingFundraisingChart.destroy();
      }

      createFundRaisingAndDistributionChart(JSON.parse(localStorage.getItem('graphData')) , currentFundraisingScope);
    }
  })

  $('#individual-fundraising-tab').on('click', e => {
    if (currentFundraisingScope === 'individual') {
      return;
    } else {
      currentFundraisingScope = 'individual';
      let existingFundraisingChart = Chart.getChart('fundraisingAndDistributionChartCanvas');

      if (existingFundraisingChart != null) {
        existingFundraisingChart.destroy();
      }

      createFundRaisingAndDistributionChart(individualFundraisingAndDistributionGraphData(), currentFundraisingScope);
    }
  })
}

function generateGraphsAndTablesFromProfilesFilter(form, currentEngagementScope, currentFundraisingScope) {
  $.ajax({
    url: form.attr('action'),
    type: 'GET',
    data: form.serialize(),
    dataType: 'script',
    success: function (data) {
      let existingEngagementChart = Chart.getChart('engagementChartCanvas');
      let existingEngagementChartCanvas = document.getElementById('engagementChartCanvas');

      if (!!existingEngagementChart) {
        existingEngagementChart.destroy();
      }

      let existingFundraisingChart = Chart.getChart('fundraisingAndDistributionChartCanvas');

      if (!!existingFundraisingChart) {
        existingFundraisingChart.destroy();
      };

      createEngagementChart(JSON.parse(localStorage.getItem('graphData')), currentEngagementScope);
      if (currentFundraisingScope === 'individual') {
        createFundRaisingAndDistributionChart(individualFundraisingAndDistributionGraphData(), currentFundraisingScope);
      } else {
        createFundRaisingAndDistributionChart(JSON.parse(localStorage.getItem('graphData')), currentFundraisingScope);
      }
    },
    error: function () {
      console.error
    }
  });
}

function initSpreadsheetExportForm() {
  let form = document.forms['export_spreadsheet']
  form.onsubmit = (e) => {
    e.preventDefault()
    $('form#export_spreadsheet>input[name="profile_ids[]"]').remove()
    const selectedEngagementTab = document.querySelector("[id$='-engagement-tab'][aria-selected='true']")
    const selectedFundraisingTab = document.querySelector("[id$='-fundraising-tab'][aria-selected='true']")
    let profileIds = document.forms['profile-filter'].elements['profile_ids[]']
    // When there's only one profile, #elements does not return an Array
    if (profileIds.constructor.name === 'HTMLInputElement') { profileIds = [profileIds] }

    for (let i = 0; i < profileIds.length; i++) {
      const input = profileIds[i];
      if (!input.checked) { continue }

      let newInput = document.createElement('input')
      newInput.type = 'hidden'
      newInput.name = 'profile_ids[]'
      newInput.value = input.value
      newInput.checked = input.checked
      form.append(newInput)
    }

    form.elements['selected_engagement_tab'].value = selectedEngagementTab.id.slice(0, selectedEngagementTab.id.search(/-/))
    form.elements['selected_fundraising_tab'].value = selectedFundraisingTab.id.slice(0, selectedFundraisingTab.id.search(/-/))
    form.submit()
  }
}

function individualFundraisingAndDistributionGraphData(params) {
  const graphData = JSON.parse(localStorage.getItem('graphData'))
  return graphData.filter(fundData => !fundData.hasCreditedTransferredSubscription)
}
